import React, { useContext, useEffect, useState } from "react";
import { Offcanvas, Form, Spinner } from "react-bootstrap";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import Select from "react-select";

function StudentFilter({ appliedFilters, show, onHide, onApplyFilter, onClear }) {
  const [filters, setFilters] = useState({
    search: appliedFilters?.search || "",
    email: appliedFilters?.email || "",
    mobile: appliedFilters?.mobile || "",
    grade_id: appliedFilters?.grade_id || "",
    school_id: appliedFilters?.school_id || "",
    course_id: appliedFilters?.course_id || "",
    status: appliedFilters?.status || "",
  });

  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const [filterOptions, setFilterOptions] = useState({
    grades: [],
    schools: [],
    courses: [],
    loading: false
  });

  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout, data } = useContext(UserContext);
  console.log("UserContext data in StudentFilter:", data);
  let school_id = data?.school?.id ?? 0;
  let user_type = data?.user_type;

  const headers = {
    "auth-token": authToken,
    "authorization": accessToken
  };

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);

  useEffect(() => {
    if (show) {
      fetchFilterOptions();
    }
  }, [show]);

  const fetchFilterOptions = async () => {
    setFilterOptions(prev => ({ ...prev, loading: true }));
    try {
      const [gradesRes, schoolsRes, coursesRes] = await Promise.all([
        APIServices.get(`/admin/cms/grade_list?status=Active&limit=100&school_id=${school_id}`, headers),
        APIServices.get(`/admin/school/short_list`, headers),
        APIServices.get(`/admin/courses/short/list`, headers)
      ]);
      console.log("Grades Response:", gradesRes);
      setFilterOptions({
        grades: gradesRes?.data?.data?.grades || gradesRes?.data?.data?.data || [],
        schools: schoolsRes?.data?.data?.data || [],
        courses: coursesRes?.data?.data?.data || [],
        loading: false
      });
    } catch (error) {
      console.error("Error fetching filter options:", error);
      setFilterOptions(prev => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    if (filterOptions.schools.length > 0 && filters.school_id) {
      const school = filterOptions.schools.find(s => s.id == filters.school_id);
      if (school) {
        setSelectedSchool({ value: school.id, label: `${school.school_name} (${school.school_code})` });
      }
    }
    if (filterOptions.courses.length > 0 && filters.course_id) {
      const course = filterOptions.courses.find(c => c.id == filters.course_id);
      if (course) {
        setSelectedCourse({ value: course.id, label: `${course.title} (${course.unique_course_id})` });
      }
    }
  }, [filterOptions.schools, filterOptions.courses, filters.school_id, filters.course_id]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleClearAll = () => {
    setFilters({
      search: "",
      email: "",
      mobile: "",
      grade_id: "",
      school_id: "",
      course_id: "",
      status: "",
    });
    if (onClear) {
      onClear();
    }
  };

  const handleApply = () => {
    const cleanedFilters = {};
    Object.keys(filters).forEach(key => {
      if (filters[key] && filters[key].trim && filters[key].trim() !== "") {
        cleanedFilters[key] = filters[key].trim();
      } else if (filters[key] && filters[key] !== "") {
        cleanedFilters[key] = filters[key];
      }
    });

    if (onApplyFilter) {
      onApplyFilter(cleanedFilters);
    }
  };

  const isFilterApplied = () => {
    return Object.values(filters).some(value => value && value !== "");
  };

  // After fetching filterOptions, transform the data
  const schoolOptions = filterOptions.schools.map(school => ({
    value: school.id,
    label: `${school.school_name} (${school.school_code})`
  }));

  const courseOptions = filterOptions.courses.map(course => ({
    value: course.id,
    label: `${course.title} (${course.unique_course_id})`
  }));

  return (
    <Offcanvas
      className="mom_filter"
      show={show}
      onHide={onHide}
      placement="end"
      backdrop="static"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="font_blue_18 font-600">
          Filter Students
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0">
        {filterOptions.loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <Form className="filter_form">
            <div className="mb-3">
              <label className="font_blue_14 font-500 mb-2">Search</label>
              <Form.Control
                type="text"
                placeholder="Search by name, email, roll number..."
                name="search"
                value={filters.search}
                onChange={handleFilterChange}
                autoComplete="off"
              />
            </div>

            <div className="mb-3">
              <label className="font_blue_14 font-500 mb-2">Mobile Number</label>
              <Form.Control
                type="text"
                placeholder="Enter mobile number"
                name="mobile"
                value={filters.mobile}
                onChange={handleFilterChange}
                autoComplete="off"
              />
            </div>

            <div className="mb-3">
              <label className="font_blue_14 font-500 mb-2">Grade</label>
              <Form.Select
                name="grade_id"
                value={filters.grade_id}
                onChange={handleFilterChange}
              >
                <option value="">All Grades</option>
                {filterOptions.grades.map((grade) => (
                  <option key={grade.id} value={grade.id}>
                    {grade.name}
                  </option>
                ))}
              </Form.Select>
            </div>

            {user_type != "school" && (
              <div className="mb-3">
                <label className="font_blue_14 font-500 mb-2">School</label>

                <Select
                  options={schoolOptions}
                  value={selectedSchool}
                  onChange={(option) => {
                    setSelectedSchool(option);
                    handleFilterChange({
                      target: {
                        name: "school_id",
                        value: option ? option.value : "",
                      },
                    });
                  }}
                  placeholder="Search and select school..."
                  isClearable
                  isSearchable
                  noOptionsMessage={() => "No schools found"}
                />
              </div>
            )}

            <div className="mb-3">
              <label className="font_blue_14 font-500 mb-2">Course</label>
              <Select
                options={courseOptions}
                value={selectedCourse}
                onChange={(option) => {
                  setSelectedCourse(option);
                  handleFilterChange({
                    target: { name: "course_id", value: option ? option.value : "" }
                  });
                }}
                placeholder="Search and select course..."
                isClearable
                isSearchable
                noOptionsMessage={() => "No courses found"}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '38px',
                    borderColor: '#ced4da'
                  })
                }}
              />
            </div>
            <div className="mb-3">
              <label className="font_blue_14 font-500 mb-2">Status</label>
              <Form.Select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
              >
                <option value="">All Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </Form.Select>
            </div>
          </Form>
        )}

        <div className="offcanvas-footer mt-4 d-flex gap-2">
          <button
            className="btn blue_border flex-grow-1"
            onClick={handleClearAll}
          >
            Clear All
          </button>
          <button
            className="btn red_button flex-grow-1"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default StudentFilter;